import styled from '@emotion/styled'
import { UploadFilesButton } from 'components/inputs/UploadFilesButton/UploadFilesButton'

const StyledUploadFilesButton = styled(UploadFilesButton)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
`

export {
  StyledUploadFilesButton as UploadFilesButton,
}
